import React from 'react';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeExternalId: (value: string) => void;
}

export const ExternalIdField: React.FC<IProps> = ({ changeExternalId }) => {
	return <FormInput testId="ExternalIdField" name="externalId" label="externalIdLabel" onChange={changeExternalId} />;
};
